
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const RedFlagsSection = () => {
  return (
    <Card className="border-red-200">
      <CardHeader>
        <CardTitle className="text-2xl text-red-700">Red Flags We Screen For</CardTitle>
        <CardDescription>
          Issues that would disqualify an investment opportunity
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-semibold text-gray-900 mb-3">Title Issues</h4>
            <ul className="space-y-2 text-gray-600">
              <li>• Outstanding liens or judgments</li>
              <li>• Clouded or disputed ownership</li>
              <li>• Unresolved legal proceedings</li>
              <li>• Missing or defective documentation</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 mb-3">Financial Red Flags</h4>
            <ul className="space-y-2 text-gray-600">
              <li>• Delinquent property taxes</li>
              <li>• Property value below investment amount</li>
              <li>• Excessive special assessments</li>
              <li>• Unrealistic payment terms</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RedFlagsSection;
